import { useRouter } from 'next/router';
import cfrUrl from '@/creditflowresearch/infrastructure/url';
import config from '@creditflowresearch/config';
import usersUrl from '@users/url';
import useLoginUrlWithConsent from '@framework/cookie-consent/useLoginUrlWithConsent';

const useLoginUrl = (): string => {
  const router = useRouter();

  return useLoginUrlWithConsent(() => {
    const callbackUrl = cfrUrl.getPropagateCallbackUrl(router.asPath);
    return usersUrl.getLoginUrl(callbackUrl, config.code);
  });
};

export default useLoginUrl;
